import { render, staticRenderFns } from "./ManageItem.vue?vue&type=template&id=69226afc&scoped=true"
import script from "./ManageItem.vue?vue&type=script&lang=js"
export * from "./ManageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69226afc",
  null
  
)

export default component.exports